import type { GiphyPluginEditorConfig } from '../types';

const getUrl = (
  getOverride: GiphyPluginEditorConfig['getGiphyUrl'],
  path: 'search' | 'trending'
) => {
  if (getOverride) {
    return getOverride(path);
  }
  if (typeof window === 'undefined') return undefined;

  return `${window.location.origin}/_serverless/ricos-giphy-proxy/${path}`;
};

export const getGiphyProxyUrl = (
  getOverride: GiphyPluginEditorConfig['getGiphyUrl'],
  params: {
    path: 'search' | 'trending';
    category: 'gifs' | 'stickers';
    limit: number;
    offset: number;
    searchTag?: string;
  }
) => {
  const url = getUrl(getOverride, params.path);

  if (!url) {
    return undefined;
  }

  const giphyUrl = new URL(url);

  if (params?.searchTag) {
    giphyUrl.searchParams.append('q', params.searchTag);
  }
  giphyUrl.searchParams.append('limit', params.limit.toString());
  giphyUrl.searchParams.append('offset', params.offset.toString());
  giphyUrl.searchParams.append('category', params.category);

  return giphyUrl;
};
